/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { idpSubmissionGetSubmissionDetailsSubmissionIdGet } from '../fn/idp-submission/idp-submission-get-submission-details-submission-id-get';
import { IdpSubmissionGetSubmissionDetailsSubmissionIdGet$Params } from '../fn/idp-submission/idp-submission-get-submission-details-submission-id-get';
import { idpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain } from '../fn/idp-submission/idp-submission-get-submission-details-submission-id-get-plain';
import { IdpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain$Params } from '../fn/idp-submission/idp-submission-get-submission-details-submission-id-get-plain';
import { idpSubmissionGetSubmissionPost } from '../fn/idp-submission/idp-submission-get-submission-post';
import { IdpSubmissionGetSubmissionPost$Params } from '../fn/idp-submission/idp-submission-get-submission-post';
import { SubmissionDetailResult } from '../models/submission-detail-result';
import { idpSubmissionGetDocumentPagesGet } from '../fn/idp-submission/idp-submission-get-document-pages-get';
import { IdpSubmissionGetDocumentPagesGet$Params } from '../fn/idp-submission/idp-submission-get-document-pages-get';
import { idpSubmissionDownloadSubmissionFilesGet } from '../fn/idp-submission/idp-submission-download-submission-files-get';
import { IdpSubmissionDownloadSubmissionFilesGet$Params } from '../fn/idp-submission/idp-submission-download-submission-files-get';
import { idpSubmissionResubmitPost } from '../fn/idp-submission/idp-submission-resubmit-post';
import { IdpSubmissionResubmitPost$Params } from '../fn/idp-submission/idp-submission-resubmit-post';
import { ResubmitResponseDto } from '../models/resubmit-response-dto';
import { idpSubmissionBulkResubmitPost } from '../fn/idp-submission/idp-submission-bulk-resubmit-post';
import { IdpSubmissionBulkResubmitPost$Params } from '../fn/idp-submission/idp-submission-bulk-resubmit-post';
import { BulkResubmitResponseDto } from '../models/bulk-resubmit-response-dto';

@Injectable({ providedIn: 'root' })
export class IdpSubmissionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `idpSubmissionGetSubmissionPost()` */
  static readonly IdpSubmissionGetSubmissionPostPath = '/IdpSubmission/GetSubmission';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `idpSubmissionGetSubmissionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  idpSubmissionGetSubmissionPost$Response(params?: IdpSubmissionGetSubmissionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return idpSubmissionGetSubmissionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `idpSubmissionGetSubmissionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  idpSubmissionGetSubmissionPost(params?: IdpSubmissionGetSubmissionPost$Params, context?: HttpContext): Observable<void> {
    return this.idpSubmissionGetSubmissionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `idpSubmissionGetSubmissionDetailsSubmissionIdGet()` */
  static readonly IdpSubmissionGetSubmissionDetailsSubmissionIdGetPath = '/IdpSubmission/GetSubmissionDetails/{submissionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `idpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  idpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain$Response(params: IdpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionDetailResult>> {
    return idpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `idpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  idpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain(params: IdpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain$Params, context?: HttpContext): Observable<SubmissionDetailResult> {
    return this.idpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionDetailResult>): SubmissionDetailResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `idpSubmissionGetSubmissionDetailsSubmissionIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  idpSubmissionGetSubmissionDetailsSubmissionIdGet$Response(params: IdpSubmissionGetSubmissionDetailsSubmissionIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionDetailResult>> {
    return idpSubmissionGetSubmissionDetailsSubmissionIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `idpSubmissionGetSubmissionDetailsSubmissionIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  idpSubmissionGetSubmissionDetailsSubmissionIdGet(params: IdpSubmissionGetSubmissionDetailsSubmissionIdGet$Params, context?: HttpContext): Observable<SubmissionDetailResult> {
    return this.idpSubmissionGetSubmissionDetailsSubmissionIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubmissionDetailResult>): SubmissionDetailResult => r.body)
    );
  }

  /** Path part for operation `idpSubmissionGetDocumentPagesGet()` */
  static readonly IdpSubmissionGetDocumentPagesGetPath = '/IdpSubmission/GetDocumentPages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `idpSubmissionGetDocumentPagesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  idpSubmissionGetDocumentPagesGet$Response(params: IdpSubmissionGetDocumentPagesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return idpSubmissionGetDocumentPagesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `idpSubmissionGetDocumentPagesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  idpSubmissionGetDocumentPagesGet(params: IdpSubmissionGetDocumentPagesGet$Params, context?: HttpContext): Observable<Blob> {
    return this.idpSubmissionGetDocumentPagesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `idpSubmissionDownloadSubmissionFilesGet()` */
  static readonly IdpSubmissionDownloadSubmissionFilesGetPath = '/IdpSubmission/DownloadSubmissionFiles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `idpSubmissionDownloadSubmissionFilesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  idpSubmissionDownloadSubmissionFilesGet$Response(params: IdpSubmissionDownloadSubmissionFilesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return idpSubmissionDownloadSubmissionFilesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `idpSubmissionDownloadSubmissionFilesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  idpSubmissionDownloadSubmissionFilesGet(params: IdpSubmissionDownloadSubmissionFilesGet$Params, context?: HttpContext): Observable<Blob> {
    return this.idpSubmissionDownloadSubmissionFilesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `idpSubmissionResubmitPost()` */
  static readonly IdpSubmissionResubmitPostPath = '/IdpSubmission/Resubmit';

  idpSubmissionResubmitPost$Response(params: IdpSubmissionResubmitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ResubmitResponseDto>> {
    return idpSubmissionResubmitPost(this.http, this.rootUrl, params, context);
  }

  idpSubmissionResubmitPost(params: IdpSubmissionResubmitPost$Params, context?: HttpContext): Observable<ResubmitResponseDto> {
    return this.idpSubmissionResubmitPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResubmitResponseDto>): ResubmitResponseDto => r.body)
    );
  }

  /** Path part for operation `idpSubmissionBulkResubmitPost()` */
  static readonly IdpSubmissionBulkResubmitPostPath = '/IdpSubmission/BulkResubmit';

  idpSubmissionBulkResubmitPost$Response(params: IdpSubmissionBulkResubmitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkResubmitResponseDto>> {
    return idpSubmissionBulkResubmitPost(this.http, this.rootUrl, params, context);
  }

  idpSubmissionBulkResubmitPost(params: IdpSubmissionBulkResubmitPost$Params, context?: HttpContext): Observable<BulkResubmitResponseDto> {
    return this.idpSubmissionBulkResubmitPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<BulkResubmitResponseDto>): BulkResubmitResponseDto => r.body)
    );
  }

}
